<video #video
class="video-js vjs-theme-sea vjs-16-9" controls preload="auto" [attr.poster]="Poster"
[attr.autoplay]="AutoPlay ? 'autoplay' : null"
>

  <source *ngFor="let item of source" [src]="item.src" [type]="item.type" />
</video>
